import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export function LogoutPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    logout()
      .catch(() => {})
      .finally(() => {
        if (!cancelled) navigate('/', { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [logout, navigate]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--ors-ink-2)' }}>
      Signing out…
    </div>
  );
}
